<a #topOfPage id="topOfPage"></a>

<div class="page-content u10g-eoia-web-ag" page-content >

  <form [formGroup]="authSignForm" (ngSubmit)="onSubmit()">
    <prism-ui-container
      is-compact="false"
      key-id="auth-sign-container"
      has-shadow="false"
      variant="default"
      has-no-border-radius="false"
      >
      <div class="containerFlex">
        <div class="item oneFlex">
          <prism-ui-copy>
            <p [innerHTML]="authSignBody"></p>
          </prism-ui-copy>
        </div>

          @if (isGenericDynamicForm) {
            <div class="item oneFlex">
              <prism-ui-copy>
                {{acknowledgementText}}
              </prism-ui-copy>
               <prism-ui-link
                key-id="release-button"
                variant="text"
                href="#acknowledgement"
                (click)="$event.preventDefault(); onAcknowledgment()"
              >Acknowledgement.</prism-ui-link>
              </div>
          }
        
          @if (isGenericDynamicForm) {
            <div class="item oneFlex">
              <prism-ui-copy>
                {{authSignSectionReleaseText}}
              </prism-ui-copy>
              <prism-ui-link
                  key-id="auth-part-one-button"
                  variant="text"
                  href="#acknowledgement-and-authorization-for-use-and-release-of-information"
                  (click)="$event.preventDefault(); onAuthPartOne()"
                >Acknowledgement and Authorization for Use and Release of Information.</prism-ui-link>
              </div>
          }
        
          @if (hasFraudNotice && !isSYN && !isNmNewYork) {
            <div class="item oneFlex">
            <prism-ui-copy>
              {{authSignSectionFraudText}}
            </prism-ui-copy>
            <prism-ui-link
              key-id="fraud-notice-button"
              variant="text"
              href="#fraud-notice"
              (click)="$event.preventDefault(); onFraud()"
            >Fraud Notice.</prism-ui-link>
            </div>
          }
        
          @if (!isGenericDynamicForm) {
            <div class="item oneFlex">
            <prism-ui-copy>
              {{authSignSectionReleaseText}}
            </prism-ui-copy>
            <prism-ui-link
              key-id="authorization-form-button"
              variant="text"
              href="#acknowledgement-and-authorization-for-use-and-release-of-information"
              (click)="$event.preventDefault(); onRelease()"
            >Acknowledgement and Authorization for Use and Release of Information.</prism-ui-link>
            </div>
          }
        
          @if (isSYN || isNmNewYork) {
            <div class="item oneFlex">
              <prism-ui-copy>
                {{benefitDisclaimerText}}
              </prism-ui-copy>
              <prism-ui-link
                key-id="info-disclaimer-button"
                variant="text"
                href="#accelerated-death-benefit-disclaimer"
                (click)="$event.preventDefault(); onBenefitDisclaimer()"
              >Accelerated Death Benefit Disclaimer.</prism-ui-link>
            </div>
          }
        <div class="item oneFlex">
          <prism-ui-copy>
            {{authSignSectionInfoText}}
          </prism-ui-copy>
          <prism-ui-link
              key-id="info-practices-notice-button"
              variant="text"
              href="#information-practices-notice"
              (click)="$event.preventDefault(); onInfo()"
            >Information Practices Notice.</prism-ui-link>
        </div>
        @if (hasFraudNotice && (isSYN || isNmNewYork)) {
          <div class="item oneFlex">
            <div class="sameLine">
              <prism-ui-copy>
                <span [innerHTML]="fraudModalContent.body.split('</p>')[0]"></span>
              </prism-ui-copy>
            </div><br>
            <prism-ui-copy>
              <span [innerHTML]="fraudModalContent.body.split('</p>')[1]"></span>
            </prism-ui-copy>
          </div>
        }

        <div class="item oneFlex">
          <prism-ui-form-field-select
            key-id="checkboxesKey"
            form-field-items-count="1"
            [isValid]="formControlUtilitiesService.setCheckboxFormValid(authSignForm)"
            >
            <span slot="error">{{authSignElement?.error}}</span>

          </prism-ui-form-field-select>
        
          <prism-ui-checkbox
            formControlName="agreedOrAcknowledged"
            [formGroup]="authSignForm"
            key-id="agreedOrAcknowledged"
            labelText="{{authSignEnd}}"
            has-multiline-label="true"
            ngDefaultControl
            (prismUiCheckboxOnChange)="formControlUtilitiesService.toggleIndividualCheckbox($event, 'agreedOrAcknowledged', authSignForm)"
            [isValid]="formControlUtilitiesService.setCheckboxFormValid(authSignForm)"
          ></prism-ui-checkbox>
        </div>
        <span [innerHTML]="authSignFooter"></span>
        </div>
      </prism-ui-container>
    
    </form>
  </div>

  @if (formSubmitted) {
    <div class="page-loader">
      <prism-ui-loader
        has-logo="false"
        is-reverse="false"
        key-id="page-loader"
        size="md"
        >
      </prism-ui-loader>
      <prism-ui-copy
        font-size="md"
        font-style="normal"
        font-weight="regular"
        key-id="test-key-id"
        line-height="medium"
        text-decoration="none"
        variant="default"
        >
        <span>Please wait while we process your request</span>
      </prism-ui-copy>
    </div>
  }

  @for (notice of noticeModals; track notice) {
    <prism-ui-modal [keyId]="notice+'-modal'" has-dark-overlay="true">
      <prism-ui-heading
        slot="modal-header"
        [keyId]="notice+'-modal'"
        font-size="sm"
        font-weight="strong"
        >{{modalContentHeading}}</prism-ui-heading
        >
        <div slot="modal-body" class="modal-body">
          <prism-ui-copy
            [keyId]="notice+'-modal'"
            [innerHTML]="modalContentBody"
            >
          </prism-ui-copy>
        </div>
     
      </prism-ui-modal>
    }
